<template>
  <v-navigation-drawer
    color="green lighten-4"
    app
    v-model="statusDrawer"
    floating
  >
    <Logo />
    <usuario-logado />
    <v-divider></v-divider>
    <v-list v-if="modulos.length > 0">
      <div v-for="(menu, i) in modulos" :key="i">
        <template v-if="menu.modulos_filhos.length == 0">
          <v-list-item
            link
            :to="{ name: menu.link }"
            active-class="green lighten-3"
            class="item-menu"
          >
            <v-list-item-action>
              <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="primary--text wrap-text subtitle-2 font-weight-bold"
                >{{ menu.descricao }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
              </v-list-item-action>
              <v-list-item-content class="item-menu">
                <v-list-item-title
                  class="primary--text wrap-text subtitle-2 font-weight-bold"
                  >{{ menu.descricao }}</v-list-item-title
                >
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(item, i) in menu.modulos_filhos"
              :key="i"
              link
              :to="{ name: item.link }"
              class="green lighten-4 item-menu"
              active-class="green lighten-3"              
            >
              <v-list-item-action> </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  class="primary--text wrap-text subtitle-2 font-weight-bold"
                  >{{ item.descricao }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </div>
    </v-list>
    <template v-slot:append>
      <v-divider></v-divider>
      <v-row class="mt-1 fixed">
        <v-col cols="12" class="pl-5 pr-5 pb-5">
          <logout />
        </v-col>
      </v-row>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Logo from "@/template/Logo";
import { mapMutations, mapState } from "vuex";
import UsuarioLogado from "./UsuarioLogado.vue";
import Logout from "./Logout.vue";

export default {
  components: {
    Logo,
    UsuarioLogado,
    Logout,
  },
  computed: {
    ...mapState("usuario", ["modulos", "drawer"]),
    statusDrawer: {
      get: function () {
        return this.drawer;
      },
      set: function (value) {
        this.setDrawer(value);
      },
    },
  },
  data: () => ({
    menus: [],
  }),
  methods: {
    ...mapMutations("usuario", ["setDrawer"]),
    isMobile() {
      return this.$mq == "sm" || this.$mq == "md";
    },
  },
};
</script>

<style scoped>
.wrap-text {
  -webkit-line-clamp: unset !important;
  white-space: unset !important;
}

.item-menu{
  min-height: 56px !important;
}
</style>